import { format } from "date-fns"
import { Regex } from "../../../../Common/Constant"

export const clientTypes = {
    EXISTING: 'Existing',
    PROSPECT: 'Prospect',
}

export const policyOwnerships = {
    INDIVIDUAL: 'individual',
    JOINT: 'joint',
}

export const clientTypeOptions = [
    { value: clientTypes.EXISTING, label: clientTypes.EXISTING },
    { value: clientTypes.PROSPECT, label: clientTypes.PROSPECT },
]

export const policyOwnershipOptions = [
    { value: policyOwnerships.INDIVIDUAL, label: "Individually Owned" },
    { value: policyOwnerships.JOINT, label: "Jointly Owned" }
]

export const getBranchOptions = (faList) => {
    if (faList && faList.length === 0) {
        return [{ label: 'Input FA ID In My Branch', value: 'INPUT' }]
    }
    else {
        return [{ label: 'Input FA ID In My Branch', value: 'INPUT' }, { label: 'Select FA ID From Another Branch', value: 'SELECT' }]
    }
}

export const validAccountDetails = (props) => {
    const regexOfficeFa = Regex.OfficeFa;
    const regexOfficeAccount = Regex.OfficeAccount;
    const isValidOfficeFa = regexOfficeFa.test(props.formState.officeFa);
    if (props.formState.clientType === "Prospect" && !props.isTerm && !props.hideClientTypeRadio) {
        if (isValidOfficeFa)
            return true;
        else
            return false;
    }
    const isValidAccountNumber = regexOfficeAccount.test(props.formState.officeAccount);
    if (isValidOfficeFa && isValidAccountNumber) {
        return true;
    } else {
        return false;
    }
}

export const getOwnerList = (ownerList) => {
    let ownerListOptions = [];

    if (ownerList !== undefined && ownerList.length !== 0) {
        ownerList.forEach((element) => {
            let middleInitial = element.middleName.charAt(0);
            ownerListOptions.push({
                label: element.firstName + ' ' + middleInitial + ' ' + element.lastName,
                value: element.covrGeneratedID
            })
        })
        return ownerListOptions;
    } else {
        return [{ label: '', value: '' }]
    }
}

export const getAdvisorList = (advisorList) => {
    let advisorListOptions = [];

    if (advisorList !== undefined && advisorList.length !== 0) {
        advisorList.forEach((element) => {
            advisorListOptions.push({ label: element.firstName + ' ' + element.lastName, value: element.agentID })
        })
        return advisorListOptions;
    } else {
        return [{ label: '', value: '' }]
    }
}

export const getQuoteList = (quoteList) => {
    let quoteListOptions = [];
    if (quoteList !== undefined && quoteList.length !== 0) {
        quoteList.map((x) => {
            quoteListOptions.push({ label: x.savedQuoteName, value: x.morganStanleySavedQuoteID })
        })
        return quoteListOptions;
    } else {
        return [{ label: '', value: '' }]
    }
}

export const getJointOwnerList = (jointOwner) => {
    let jointOwnerListOptions = [];

    if (jointOwner !== undefined && jointOwner.length !== 0) {
        jointOwner.forEach((element) => {
            let middleInitial = element.middleName.charAt(0);
            jointOwnerListOptions.push({
                label: element.firstName + ' ' + middleInitial + ' ' + element.lastName,
                value: element.covrGeneratedID
            })
        })
        return jointOwnerListOptions;
    } else {
        return [{ label: '', value: '' }]
    }
}

export const getMatchingOwnerList = (list, firstName, lastName, dob) => {
    if (!list || list.length === 0) return [];

    const hasFilters = Boolean(firstName || lastName || dob);
    if (!hasFilters) return [];

    return list.filter((item) => {
        let isMatch = true;

        if (firstName || lastName) {
            const inputFullName = (firstName + lastName).toLowerCase();
            const ownerFullName = (item.firstName + item.lastName).toLowerCase();
            isMatch = isMatch && (inputFullName.trim() === ownerFullName.trim());
        }

        if (dob) {
            const itemDob = item.dateOfBirth
                ? format(new Date(item.dateOfBirth), "MM/dd/yyyy")
                : null;

            isMatch = isMatch && itemDob === dob;
        }

        return isMatch;
    });
};


// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/RetrieveAccount/Helpers/Constants.js